module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "body-2",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', [_c('label', [_vm._v("Please provide an overview of this campaign brief, include pointers to note for your stakeholders to support in getting the brief approved, ie past conversations with client")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": "",
      "error-messages": _vm.$v.updateData.remarks.$error && "This field is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.remarks.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.remarks.$touch()
      }
    },
    model: {
      value: (_vm.updateData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "remarks", $$v)
      },
      expression: "updateData.remarks"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Deadline")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "error-messages": _vm.$v.updateData.deadline.$error && "Deadline is required.",
            "append-icon": "event",
            "outlined": "",
            "readonly": ""
          },
          on: {
            "input": function($event) {
              return _vm.$v.updateData.deadline.$touch()
            },
            "blur": function($event) {
              return _vm.$v.updateData.deadline.$touch()
            }
          },
          model: {
            value: (_vm.updateData.deadline),
            callback: function($$v) {
              _vm.$set(_vm.updateData, "deadline", $$v)
            },
            expression: "updateData.deadline"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.deadlineCal),
      callback: function($$v) {
        _vm.deadlineCal = $$v
      },
      expression: "deadlineCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.deadlineCal = false
      }
    },
    model: {
      value: (_vm.updateData.deadline),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "deadline", $$v)
      },
      expression: "updateData.deadline"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Release to CC")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f94c6f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReleaseToCcModal.vue
// module id = 2005
// module chunks = 0